import RedesignPageLayout from '../../components/common/RedesignPageLayout';
import AdminBlogRequest from '../../components/admin/AdminBlogRequest';

export default function AdminBlogRequestPage() {
    return (
        <RedesignPageLayout>
            <AdminBlogRequest />
        </RedesignPageLayout>
    );
}
